import { useEffect } from "react";
import { holdNavigation } from "./deferredNavigation";

// While `active`, reloads and redirects the app starts itself (a location
// switch, an expired sign-in, ...) wait instead of ending this screen's own
// recording (see utils/deferredNavigation). Released when `active` turns
// false or the component unmounts.
export default function useNavigationHold(active) {
  useEffect(() => {
    if (!active) return undefined;
    return holdNavigation();
  }, [active]);
}
